import { render } from "./UserGroup.vue?vue&type=template&id=5bb9db42"
import script from "./UserGroup.vue?vue&type=script&lang=js"
export * from "./UserGroup.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5bb9db42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bb9db42', script)) {
    api.reload('5bb9db42', script)
  }
  
  module.hot.accept("./UserGroup.vue?vue&type=template&id=5bb9db42", () => {
    api.rerender('5bb9db42', render)
  })

}

script.__file = "src/icons/components/filled/UserGroup.vue"

export default script